// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d7e3c4f8","container":"b36baa49","value":"c654cf86","subtitle":"fca1d74a","disabledLink":"b200f970"};